import React from 'react';

interface SizeCellProps {
  size: number;
}

const SizeCell: React.FC<SizeCellProps> = ({ size }) => {
    const color = size > 2 ? 'bg-green-100 text-green-800' : 'bg-purple-100 text-purple-800';
  return (
    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${color}`}>
      {size.toString()}
    </span>
  );
};

export default SizeCell; 